import { ruleItems } from '@/mocks/haijiao';

export default function Rules() {
  return (
    <section id="rules" className="bg-background-100/60 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
          <div>
            <p className="text-sm font-semibold tracking-widest text-primary-600">海角吃瓜规则</p>
            <h2 className="mt-3 font-heading text-3xl font-bold leading-tight tracking-tight text-foreground-950 md:text-4xl">
              边界立好了，
              <br />
              围观才更长久
            </h2>
            <p className="mt-5 max-w-sm text-base leading-relaxed text-foreground-600">
              规则不是束缚，而是一起好好吃瓜的共同约定。四条底线，请大家一起守住。
            </p>
            <div className="mt-8 overflow-hidden rounded-2xl bg-primary-500 p-6 text-white">
              <i className="ri-shield-check-line text-3xl"></i>
              <p className="mt-3 font-heading text-xl font-semibold">理性围观 · 温柔表达</p>
              <p className="mt-2 text-sm leading-relaxed text-white/85">
                把这里的每一份热闹，都变成有质量的讨论。
              </p>
            </div>
          </div>

          <ul className="grid gap-4 sm:grid-cols-2">
            {ruleItems.map((r) => (
              <li
                key={r.key}
                className="flex flex-col rounded-2xl bg-background-50 p-6 transition-colors hover:bg-background-100"
              >
                <span className="font-heading text-sm font-semibold tracking-widest text-accent-500">
                  {r.key}
                </span>
                <h3 className="mt-2 text-lg font-semibold text-foreground-950">{r.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{r.desc}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}